import type { GameState } from '../../engine/game-state.js';
import { createGrid, CLASSIC_LAYOUT } from '../../render/classic/layout.js';
import type { ClassicSpec } from '../../render/classic/types.js';
import { CARD_W, CARD_H } from '../../render/classic/types.js';
import {
  CELL_IDS,
  FOUNDATION_IDS,
  TABLEAU_IDS,
  freecellRules,
  hasAnyLegalMove,
  isAltColorDescending,
  maxSupermoveSize,
} from './rules.js';

// 8 columns wide. Top row holds 4 cells + 4 foundations (8 slots). Tableau
// row sits below with 8 fan-down columns.
const COLS = 8;
const TOP_Y = 24;
const TABLEAU_Y = TOP_Y + CARD_H + CLASSIC_LAYOUT.ROW_GAP;
const FELT_W = COLS * CARD_W + (COLS - 1) * CLASSIC_LAYOUT.COL_GAP + 48;
const FELT_H = TABLEAU_Y + CARD_H + 19 * CLASSIC_LAYOUT.FAN_DOWN + 24;

const layout = createGrid({
  cols: COLS,
  feltWidth: FELT_W,
  rows: [
    { y: TOP_Y, slots: [...CELL_IDS, ...FOUNDATION_IDS] },
    { y: TABLEAU_Y, fanDown: true, slots: [...TABLEAU_IDS] },
  ],
});

function dragStackIds(state: GameState, cardId: string): string[] {
  for (const pile of Object.values(state.piles)) {
    const idx = pile.cards.findIndex((c) => c.id === cardId);
    if (idx === -1) continue;
    if (pile.type !== 'tableau') {
      if (idx !== pile.cards.length - 1) return [];
      return [cardId];
    }
    const sequence = pile.cards.slice(idx);
    if (!isAltColorDescending(sequence)) return [];
    if (sequence.length > maxSupermoveSize(state, false)) return [];
    return sequence.map((c) => c.id);
  }
  return [];
}

export const freecellClassicSpec: ClassicSpec = {
  rules: freecellRules,
  feltWidth: FELT_W,
  feltHeight: FELT_H,
  slotForPile: (id) => layout.slot(id),
  dropExclude: () => [],
  dragStackIds,
  autoSendOrder: () => [...FOUNDATION_IDS, ...TABLEAU_IDS, ...CELL_IDS],
  statusText(state) {
    if (!hasAnyLegalMove(state)) return 'No moves left';
    return null;
  },
};

void CARD_W; void CARD_H; // keep imports tree-shake-safe
